if (!customElements.get('sk-country-picker')) {
  customElements.define('sk-country-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const toggle = this.querySelector('.sk-country-toggle');
      const panel = this.querySelector('.sk-country-panel');
      const search = this.querySelector('input[type=search]');
      const options = [...this.querySelectorAll('.sk-country-option')];
      const empty = this.querySelector('.sk-country-empty');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const close = () => { panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); };
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        // Dawn treats drawer buttons as close controls; keep selector interaction local.
        event.stopPropagation();
        if (button !== toggle) return;
        panel.hidden = !panel.hidden;
        toggle.setAttribute('aria-expanded', String(!panel.hidden));
        // Avoid opening a phone keyboard merely to choose a destination.
      }, true);
      search.addEventListener('input', () => {
        const query = normalize(search.value);
        options.forEach(option => { option.hidden = !normalize(option.textContent + ' ' + option.value).includes(query); });
        empty.hidden = options.some(option => !option.hidden);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) {
          event.stopPropagation(); panel.hidden = true; toggle.setAttribute('aria-expanded', 'false'); toggle.focus();
        }
      });
      this.outside = event => { if (!this.contains(event.target)) close(); };
      document.addEventListener('click', this.outside);
    }
    disconnectedCallback() { document.removeEventListener('click', this.outside); }
  });
}

// Runs before the document-capture cart bridge reads FormData.
// Owner rule: DE/AT/CH => de; unmapped or unsupported language => en.
// Extend picker JSON only after publishing and testing the new language route.
window.addEventListener('submit', event => {
  const form = event.target;
  const picker = form instanceof HTMLFormElement ? form.closest('sk-country-picker') : null;
  if (!picker || event.submitter?.name !== 'country_code') return;
  const input = form.querySelector('input[name="language_code"]');
  const rules = JSON.parse(picker.querySelector('[data-country-language-map]').textContent);
  const supported = new Set(picker.dataset.languages.split(','));
  const desired = rules[event.submitter.value] || 'en';
  input.value = supported.has(desired) ? desired : 'en';
}, true);

